import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { statusColor } from '../../status-colors';

@Component({
  selector: 'app-status-badge',
  imports: [CommonModule],
  templateUrl: './status-badge.html',
  styleUrl: './status-badge.scss',
})
export class StatusBadge {
  @Input({ required: true }) status!: string;
  @Input() label?: string;

  get color() {
    return statusColor(this.status);
  }
}
